import { FuseNavigation } from '@fuse/types';
 
export const navigation: FuseNavigation[] = [
 
    {
        id: 'dashboards',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARDS',
        type: 'item',
        icon: 'account_circle',
        url: '/apps/dashboard'        
    },
    {
        id: 'userrolepermission',
        title: 'User Role Permission',
        translate: 'NAV.UserRole',
        type: 'item',
        icon: 'people_outline',
        url: '/apps/user-role-permission/userroleList',
        // iconImage:'../../assets/icons/User Role Permission 16x16.png'
    },
 
    {
        id: 'AutoTransfer',
        title: 'Auto Transfer',
        translate: 'Auto Transfer',
        type: 'collapsable',
        // icon: 'assignment',
        iconImage:'../assets/icons/reportW.svg',
        children: [
        {
            id: 'Companybase',
            title: 'Company Base',
            translate: 'NAV.CompanyBases',
            type: 'item',
            icon: 'domain',
            url: '/apps/company-bases/companybasesList',
 
        },
        {
            id: 'Individualbase',
            title: 'Individual Base',
            translate: 'NAV.Individualbase',
            type: 'item',
            icon: 'person',
            url: '/apps/IndividualBase/IndividualbaseList',
            // iconImage:'../../assets/icons/Individual Base 16x16.png'
 
        },
        {
            id: 'Transferdetails',
            title: 'Transfer Detail',
            translate: 'NAV.Transferdetails',
            type: 'item',
            icon: 'local_atm',
            url: '/apps/TransferDetails/TransferDetialsList',
            // iconImage:'../../assets/icons/Transfer Detail 16x16.png'
 
        },
        {
            id: 'blocktransfer',
            title: 'Block Transfer',
            translate: 'NAV.blocktransfer',
            type: 'item',
            icon: 'today',
            url: '/apps/block-transfer/BlocktransferLists',
 
 
        },
        {
            id: 'report',
            title: 'Report',
            translate: 'Report',
            type: 'collapsable',
            // icon: 'assignment',
            iconImage:'../assets/icons/reportW.svg',
           
       
            children: [
                {
                    id: 'AutomaticTransferDetailReport',
                    title: 'Automatic Transfer Detail',
                    type: 'collapsable',
                    //icon: 'file_copy',
                    url: '/apps/report/AutomaticTransferDetailReport',
                    iconImage:'./assets/icons/transfer-details-white.svg',
                    activeImage:'./assets/icons/transfer-details.svg'
                },
                {
                    id: 'AutomaticTransferAmountReport',
                    title: 'Automatic Transfer Amount',
                    type: 'collapsable',
                // icon: 'file_copy',
                    url: '/apps/report/AutomaticTransferAmountReport',
                    iconImage:'./assets/icons/transfer-amount-white.svg',
                    activeImage:'./assets/icons/transfer-amount.svg'
                    // activeImage:'../../assets/icons/Transfer Amount_active.png'
                },
                {
                    id: 'AutomaticTransferStatusReport',
                    title: 'Automatic Transfer Status',
                    type: 'collapsable',
                    //icon: 'file_copy',
                    url: '/apps/report/AutomaticTransferStatusReport',
                    iconImage:'./assets/icons/transfer-status-white.svg',
                    activeImage:'./assets/icons/transfer-status.svg'
                    // activeImage:'../../assets/icons/Transfer Status_active.png'
                },
                {
                    id: 'AutomaticTransferGroupbyReport',
                    title: 'Automatic Transfer Group By',
                    type: 'collapsable',
                    icon: 'file_copy',
                    url: '/apps/report/AutomaticTransferGroupByReport'
                }
            ]
        },
        ]
    },
    {
        id: 'AutoRepayment',
        title: 'Auto Repayment',
        translate: 'Auto Repayment',
        type: 'collapsable',
        // icon: 'assignment',
        iconImage:'../assets/icons/autopay-white.svg',
        children: [
        {
            id: 'CompanybaseRp',
            title: 'Auto Pay Company Base',
            translate: 'NAV.autopaycompanybase',
            type: 'item',
            url: '/apps/autopay-company-bases/autopaycompanybasesList',
            icon: 'domain',
            activeImage:'./assets/icons/autopay-company-base.svg'
 
        },
        {
            id: 'IndividualbaseRp',
            title: 'Auto Pay Individual Base',
            translate: 'NAV.autopayindividualbase',
            type: 'item',
            url: '/apps/autopay-individual-bases/autopayindividualbasesList',
            icon: 'person',
            activeImage:'./assets/icons/autopay-individual-base.svg'
            // iconImage:'../../assets/icons/Individual Base 16x16.png'
 
        },
        {
            id: 'TransferdetailsRp',
            title: 'Auto Pay Transfer Detail',
            translate: 'NAV.autopaytransferdetails',
            type: 'item',
            url: '/apps/autopay-transfer-detail/autopaytransferdetail',
            icon: 'local_atm',
            activeImage:'./assets/icons/autopay-transfer-details.svg'
            // iconImage:'../../assets/icons/Transfer Detail 16x16.png'
        },
 
        // {
        //     id: 'blocktransfers',
        //     title: 'Auto Pay Block Transfers',
        //     translate: 'NAV.autoblocktransfer',
        //     type: 'item',
        //     icon: 'today',
        //     url: '/apps/block-transfers/BlocktransferLists',
 
        // },
 
 
            {
            id: 'reportRp',
            title: 'Auto Pay Report',
            translate: 'NAV.autopayreport',
            type: 'collapsable',
            // icon: 'assignment',
            iconImage:'../assets/icons/autopay-report-white.svg',
           
       
            children: [
                {
                    id: 'AutomaticTransferDetailReport',
                    title: 'Auto Pay Transfer Detail',
                    type: 'collapsable',
                    //icon: 'file_copy',
                    url: '/apps/AutopayReport/AutopayTransferDetailReport',
                    iconImage:'./assets/icons/autopay-transfer-details-report-white.svg',
                    activeImage:'./assets/icons/autopay-transfer-details-report.svg',
                },
                // {
                //     id: 'AutomaticTransferAmountReport',
                //     title: 'Automatic Transfer Amount',
                //     type: 'item',
                //     url: '/apps/AutopayReport/AutopayTransferAmountReport',
                //     iconImage:'./assets/icons/transfer-amount-white.svg',
                //     activeImage:'./assets/icons/transfer-amount.svg'
                // },
                {
                    id: 'AutomaticTransferStatusReport',
                    title: 'Auto Pay Transfer Status',
                    type: 'collapsable',
                    //icon: 'file_copy',
                    url: '/apps/AutopayReport/AutopayTransferStatusReport',
                    iconImage:'./assets/icons/autopay-transfer-status-report-white.svg',
                    activeImage:'./assets/icons/autopay-transfer-status-report.svg'
                    // activeImage:'../../assets/icons/Transfer Status_active.png'
                },
                {
                    id: 'AutomaticTransferGroupbyReport',
                    title: 'Auto Pay Group By',
                    type: 'collapsable',
                    url: '/apps/AutopayReport/AutopayGroupbyReport',
                    iconImage:'./assets/icons/autopay-groupby-report-white.svg',
                    activeImage:'./assets/icons/autopay-groupby-report.svg'
                }
            ]
        },
        ]
    },
    {
        id: 'Changepassword',
        title: 'Change Password',
        translate: 'NAV.changepassword',
        type: 'item',
        icon: 'lock',
        url: '/apps/changepassword/changepassword',
        // iconImage:'../../assets/icons/Change Password 16x16.png'
    },
    {
        id: 'Logout',
        title: 'logout',
        translate: 'Logout',
        type: 'item',
        icon: 'power_settings_new',
        url: '/apps/logout/logout',
 
    },
];